// src/firebaseConfig.js
// Initialize Firebase
import { initializeApp } from "firebase/app";
import {
    getAuth,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    signOut,
    onAuthStateChanged,
    signInWithPopup,
    GoogleAuthProvider
} from "firebase/auth";

import { getFirestore } from 'firebase/firestore';
import { getAnalytics, setAnalyticsCollectionEnabled, logEvent } from 'firebase/analytics';
import { hasConsentedAnalytics } from './Utils/consent.js';

const firebaseConfig = {
    apiKey: "AIzaSyCSWJ6BbN7gZEDEn1afTAgMrm9SzgJ5WB0",
    authDomain: "storiagl.firebaseapp.com",
    projectId: "storiagl",
    storageBucket: "storiagl.appspot.com",
    messagingSenderId: "506902913567",
    appId: "1:506902913567:web:0055411cd986de2cc6ab2a"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
// IMPORTANT: Only enable Analytics if user consented
let analytics;
try {
    analytics = getAnalytics(app);
    const consented = hasConsentedAnalytics();
    setAnalyticsCollectionEnabled(analytics, !!consented);
} catch (e) {
    // getAnalytics can throw on non-browser or unsupported env
    analytics = undefined;
}

export { logEvent, db, analytics, app, auth, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut, onAuthStateChanged, signInWithPopup, GoogleAuthProvider };